






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  Used to render a price including an optional subtext.
 */
@Component
export default class Price extends Vue {

    /**
     *  The price to show (in cents).
     */
    @Prop({ type: Number, required: true })
    private price!: number;

    /**
     *  If it should be aligned to the right.
     */
    @Prop({ type: Boolean })
    private rightAligned!: boolean;

    /**
     *  If it should be small.
     */
    @Prop({ type: Boolean })
    private small!: boolean;

    /**
     *  Used to format the price into a (Dutch) human readable price.
     */
    private formatter: Intl.NumberFormat = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    /**
     *  Used to get the formatted price.
     */
    private get formattedPrice(): string {

        return this.formatter.format(this.price / 100);

    }

}
